import type { AssessmentActivitiesByParentIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAssessmentActivitiesByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentActivitiesByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetAssessmentActivitiesByParentIdArgs = {
  id: string;
};

export const useLazyGetAssessmentActivitiesByParentId = createLazyQueryHook<
  UseLazyGetAssessmentActivitiesByParentIdArgs,
  AssessmentActivitiesByParentIdResponseRow[],
  GetAssessmentActivitiesByParentIdQuery
>({
  trpcQuery: (client, { id }) =>
    client.frontend.assessment.assessmentActivitiesByParentId.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ assessment_activity: data }),
  graphqlDocument: GetAssessmentActivitiesByParentIdDocument,
  graphqlVariables: ({ id }) => ({ AssessmentId: id }),
});
